const urlCreate = `/api/app/create-donate?api_key=${TheApp.CurrentContext.app.jsApiKey}`;
const urlCapture = `/api/app/capture-order?api_key=${TheApp.CurrentContext.app.jsApiKey}`;

export default function paypal({
    elem,
    data,
    onSuccess = null,
    onCancel = null,
    onError = null,
    onCreateError = null,
    setLoading = null
}) {
    let errorTriggered = false;

    return window.paypal.Buttons({
        createOrder: (_data, actions) => {
            return fetch(urlCreate, {
                method: "post",
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                    ContentLocale: TheApp.ContentLocale,
                    Data: data
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data?.Errors?.length > 0) {
                        const { Errors } = data;
                        onCreateError?.({ Errors });
                        errorTriggered = true;
                    }

                    return data.OrderId;
                })
        },
        onApprove: (data, actions) => {
            setLoading?.(true);
            const rq = { OrderId: data.orderID };

            return fetch(urlCapture, {
                method: "post",
                headers: { "content-type": "application/json" },
                body: JSON.stringify(rq)
            })
                .then(res => res.json())
                .then(res => {
                    setLoading?.(false);

                    if (res.Status === "OK") {
                        onSuccess?.(res, data);
                        return;
                    }

                    if (!errorTriggered)
                        onError?.() ;
                });
        },
        onCancel: (data) => {
            onCancel?.(data);
        },
        onError: (err) => {
            console.log("onError", err);
            if (!errorTriggered)
                onError?.();
        }
    }).render(elem);
}